import { Pill } from './Pill';

export { Pill };
